/**
 * DataTableCellIconStatus class
 *
 * @package    DataTable
 * @author     Roman Kritskiy <rkirtskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ScheduleIcon from '@material-ui/icons/Schedule';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import GradeIcon from 'Layouts/Layout/images/star.svg';

import { DataTableColumnType, DataTableItemType } from 'Types';

export default class DataTableCellIconStatus extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        column: DataTableColumnType,
        value: PropTypes.any,
        item: DataTableItemType.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    renderStatusIcon = () => {
        const { item } = this.props;

        if (item.is_overdue) {
            return <ScheduleIcon titleAccess={this.context.intl.formatMessage({ id: 'icon.title.overdue' })} />;
        } else if (item.is_new) {
            return <ArrowForwardIcon titleAccess={this.context.intl.formatMessage({ id: 'icon.title.new' })} />;
        }

        return '';
    };

    renderNotificationIcon = () => {
        const { item } = this.props;
        return item.has_notification ? <img src={GradeIcon} alt="GradeIcon" /> : '';
    };

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        return (
            <div className='table-icons-wrap'>
                {this.renderStatusIcon()}
                {this.renderNotificationIcon()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableBody/DataTableCells/DataTableCellIconStatus.jsx